module.exports = __webpack_public_path__ + "media/images/unionpay-e440419c9ea27175bba8ed9902faf78e.jpg";